import { FolderFileKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderFilePdfConvertQueueRequest, GetFolderFilePdfConvertQueueResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useFolderFilePdfConvertQueueQuery(
  req: GetFolderFilePdfConvertQueueRequest,
  options?: SimpleQueryOptions<GetFolderFilePdfConvertQueueResponse, GetFolderFilePdfConvertQueueRequest>
) {
  return useBaseQuery({
    queryKey: [FolderFileKey.FolderFilePdfConvertQueue, String(req.fileId)],
    fnOption: { url: FolderFileUrl.getFolderFilePdfConvertQueue(req.fileId) },
    ...options,
  });
}
